module.exports = __webpack_public_path__ + "img/water-drop-with-bg-blue.d1433fd4.png";